var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":_vm.maxlength,"type":"text"},domProps:{"value":_vm.value},on:{"change":_vm.onInputChangeHandler,"input":_vm.onInputChangeHandler,"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }